export default __webpack_public_path__ + "static/media/ic_palestine.32c8dd16.svg";